import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./VerticalMenu.css";

const VerticalMenu = () => {
  const location = useLocation();
  const [userRole, setUserRole] = useState('');

  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      try {
        const parsedUser = JSON.parse(userData);
        const role = parsedUser.role ? parsedUser.role.toLowerCase() : '';
        console.log('VerticalMenu - Raw role:', parsedUser.role);
        console.log('VerticalMenu - Lowercase role:', role);
        setUserRole(role);
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  const isActive = (path) => {
    return location.pathname === path;
  };

  const isExamManager = userRole === 'exam_manager';
  const isAdmin = userRole === 'admin';
  
  console.log('VerticalMenu - userRole:', userRole);
  console.log('VerticalMenu - isExamManager:', isExamManager);
  console.log('VerticalMenu - isAdmin:', isAdmin);

  return (
    <div className="vertical-menu">
      <div className="menu-header">
        <h1 className="menu-title" style={{color: 'white'}}>Goethe Exam</h1>
        <p className="menu-subtitle">Management System</p>
      </div>

      <div className="menu-section">
        <h2 className="menu-section-title">Main Operations</h2>
                <Link 
          to="/prepare-olymp" 
          className={`menu-item ${isActive('/prepare-olymp') ? 'active' : ''}`}
        >
          <span className="menu-item-icon">📤</span>
          Prepare List to Olymp
        </Link>
        <Link 
          to="/upload-files" 
          className={`menu-item ${isActive('/upload-files') ? 'active' : ''}`}
        >
          <span className="menu-item-icon">📤</span>
          Upload Files
        </Link>
        
        <Link 
          to="/organize-exam" 
          className={`menu-item ${isActive('/organize-exam') ? 'active' : ''}`}
        >
          <span className="menu-item-icon">📋</span>
          Organize Exam
        </Link>
        
        <Link 
          to="/seating-assignments" 
          className={`menu-item ${isActive('/seating-assignments') ? 'active' : ''}`}
        >
          <span className="menu-item-icon">🪑</span>
          View Seating Assignments
        </Link>
        
        <Link 
          to="/my-profile" 
          className={`menu-item ${isActive('/my-profile') ? 'active' : ''}`}
        >
          <span className="menu-item-icon">👤</span>
          My Profile
        </Link>
      </div>

      <div className="menu-divider"></div>

      {(isAdmin || isExamManager) && (
        <div className="menu-section">
          <h2 className="menu-section-title">Administration</h2>
          
          {isExamManager ? (
            // Exam Manager only sees Rooms
            <Link 
              to="/admin?tab=rooms" 
              className={`menu-item ${location.search.includes('tab=rooms') ? 'active' : ''}`}
            >
              <span className="menu-item-icon">🏠</span>
              Rooms
            </Link>
          ) : (
            // Admin sees all options
            <>
              <Link 
                to="/admin" 
                className={`menu-item ${isActive('/admin') ? 'active' : ''}`}
              >
                <span className="menu-item-icon">⚙️</span>
                Admin Panel
              </Link>
              
              <Link 
                to="/admin?tab=levels" 
                className={`menu-item ${location.search.includes('tab=levels') ? 'active' : ''}`}
              >
                <span className="menu-item-icon">📊</span>
                Levels
              </Link>
              
              <Link 
                to="/admin?tab=rooms" 
                className={`menu-item ${location.search.includes('tab=rooms') ? 'active' : ''}`}
              >
                <span className="menu-item-icon">🏠</span>
                Rooms
              </Link>
              
              <Link 
                to="/admin?tab=modules" 
                className={`menu-item ${location.search.includes('tab=modules') ? 'active' : ''}`}
              >
                <span className="menu-item-icon">📚</span>
                Modules
              </Link>
              
              <Link 
                to="/admin?tab=template" 
                className={`menu-item ${location.search.includes('tab=template') ? 'active' : ''}`}
              >
                <span className="menu-item-icon">📝</span>
                Template Editor
              </Link>
              
              <Link 
                to="/admin?tab=users" 
                className={`menu-item ${location.search.includes('tab=users') ? 'active' : ''}`}
              >
                <span className="menu-item-icon">👥</span>
                Users
              </Link>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default VerticalMenu;
